module.exports = __webpack_public_path__ + "static/img/1034.ffdfaa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1034.jpg
// module id = 216
// module chunks = 0